'use client';

import { usePathname } from 'next/navigation';

import { Image } from '@/components/Default/Image';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    LinkedinShareButton
} from 'next-share';

const Share = () => {
    const pathname = usePathname();
    const pageHref = process.env.NEXT_PUBLIC_APP_URL + pathname;

    return (
        <div className='flex items-center gap-x-4 border-t my-16 pt-8'>
            <span className='font-semibold text-lg sm:text-xl'>Deel dit artikel:</span>
            <FacebookShareButton url={pageHref}>
                <Image src='/assets/share/facebook.svg' width={24} height={24} alt='Facebook' />
            </FacebookShareButton>
            <TwitterShareButton url={pageHref}>
                <Image src='/assets/share/x.svg' width={24} height={24} alt='X' />
            </TwitterShareButton>
            <WhatsappShareButton url={pageHref}>
                <Image src='/assets/share/whatsapp.svg' width={24} height={24} alt='Whatsapp' />
            </WhatsappShareButton>
            <LinkedinShareButton url={pageHref}>
                <Image src='/assets/share/linkedin.svg' width={24} height={24} alt='LinkedIn' />
            </LinkedinShareButton>

        </div>
    );
};

export { Share };